import CrudActionSetBase from './CrudActionSetBase'

export class OfferActionSet extends CrudActionSetBase('offer'){}
export default new OfferActionSet()